import Schema, { optional, array, required } from 'AppReact/schema';
import customDropdownInternalState from '../customDropdown/internalState';

export default {
  ...customDropdownInternalState,
  action: Schema('string', 'primitive-nullable', { defaultValue: "add_new" }),
  textButtonFontWeight: Schema('string', 'primitive-nullable', { defaultValue: null }),
  fontSize: Schema('string', 'primitive-nullable', { defaultValue: null }),
  showAddButton: Schema('boolean', 'primitive', { defaultValue: false }),
  personSelector: Schema('boolean', 'primitive', { defaultValue: false }),
}
